<template>
  <main-layout>
    <p>
      I grew up in the suburbs of Boston. I started my studies at Tufts in the
      fall of 2015, and have been pursuing majors in computer science and
      physics. In my free time, I like to make simple web apps and video games.
      You can find links to, and descriptions of, the projects I'm most proud
      of in the 'Projects' tab (coming soon!).
    </p>
    <p>
      When I'm not chasing bugs, I can be found reading a sci-fi or fantasy
      novel, particularly one by R.A. Salvatore, Timothy Zahn, or Brandon
      Sanderson, or designing the next dungeon in my D&amp;D campaign. I'm always on
      the hunt for a well-designed D&amp;D module or a realized fantasy setting, so
      don't be afraid to reach out!
    </p>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'

	export default {
  	components: {
  		MainLayout
    },
		name: "bio"
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Bio.vue?00e39e8c